var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLD(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 0.368922C32 0.130854 31.7182 0.00514866 31.541 0.164222L5.22795 23.796C5.10622 23.9053 5.10623 24.0961 5.22795 24.2054L31.5411 47.8372C31.7182 47.9963 32 47.8706 32 47.6325L32 33.6525C32 33.5726 31.9654 33.4967 31.905 33.4445L21.2402 24.2085C21.1135 24.0988 21.1135 23.9022 21.2402 23.7925L31.905 14.5565C31.9654 14.5042 32 14.4283 32 14.3485L32 0.368922Z",
    fill: "#91A0AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2887 24.2333C31.1401 24.1132 31.1401 23.8868 31.2887 23.7667L38.0114 18.3327C38.2076 18.1742 38.5 18.3138 38.5 18.5661L38.5 29.4339C38.5 29.6862 38.2076 29.8258 38.0114 29.6673L31.2887 24.2333Z",
    fill: "#91A0AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLD);
export default __webpack_public_path__ + "static/media/ArrowL_D.aadbb23a5cc45bd66dde8bc6a1088e2b.svg";
export { ForwardRef as ReactComponent };